import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const SearchSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M3.132 5.133a4.93 4.93 0 0 0 1.804 6.735 4.934 4.934 0 0 0 6.736-1.804A4.934 4.934 0 0 0 6.41 2.768c-1.805.348-2.938 1.722-3.278 2.365"
    />
    <path stroke="currentcolor" strokeLinecap="round" d="m10.844 11.248 3.115 3.116" />
  </IconV2>
);

export default SearchSmallIcon;
